"use client";
import { cn as n } from "../../../utils/cn.js";
const d = {
  base: "flex flex-col gap-indent bg-component text-component-foreground",
  size: {
    md: "rounded-2xl p-2",
    lg: "rounded-3xl p-5"
  },
  wideSticky: {
    md: n(
      "-mx-container px-container rounded-none",
      "md:m-0 md:rounded-2xl md:p-2"
    ),
    lg: n(
      "-mx-container px-container rounded-none",
      "md:m-0 md:p-5 lg:rounded-3xl"
    )
  }
};
export {
  d as stylesCard
};
